import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../common/common.scss";

export default function DialogBox({
  width,
  openPopup = false,
  mesage,
  children,
  onClose,
  setOpenPopup,
  modalOverApex = false,
}) {
  const handleClose = () => {
    setOpenPopup?.(false);
    onClose?.();
  };

  return (
    <div className="w-50">
      <Dialog
        maxWidth={width}
        sx={
          modalOverApex
            ? { textAlign: "center", zIndex: "13000001" }
            : { textAlign: "center" }
        }
        fullWidth={true}
        open={Boolean(openPopup)}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          id="alert-dialog-title mt-5"
          className="bg-white mt-2"
          sx={{ padding: "0 !important" }}
        >
          {onClose ? (
            <Button onClick={handleClose} className="modal-close-btn">
              <CloseIcon sx={{ color: "#9CB8A6" }} />
            </Button>
          ) : null}
          {mesage}
          {children}
        </DialogContent>
      </Dialog>
    </div>
  );
}
